import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, AfterViewInit, Output, ViewChild } from '@angular/core';
import { peerToPeerInfo } from 'app/manage-p2p/features/p2p.actions';
import { Store, select } from '@ngrx/store';
import { ModalP2pAddDonationsService } from 'app/manage-p2p/services/modal-p2p-add-donations/modal-p2p-add-donations.service';
import { PeerToPeerManageService } from 'app/manage-p2p/services/peer-to-peer-manage/peer-to-peer-manage.service';
import { DomSanitizer } from '@angular/platform-browser';
import { selectModalPledges, selectP2PDonations } from 'app/manage-p2p/features/p2p.selectors';
import { P2pDetailsDonationsInfoComponent } from '../p2p-details-donations-info/p2p-details-donations-info.component';
import { CommonModule } from '@angular/common';
import { MdbTabsComponent, MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { CampaignTabsService } from 'app/campaign/services';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { ConfirmModalComponent } from 'app/core/components/modals/confirm-modal/confirm-modal.component';
import { P2pDonationsPopoverComponent } from '../p2p-donations-popover/p2p-donations-popover.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  standalone: true,
  selector: 'app-p2p-details-donations',
  templateUrl: './p2p-details-donations.component.html',
  styleUrl: './p2p-details-donations.component.scss',
  imports:[CommonModule, P2pDetailsDonationsInfoComponent, MdbTabsModule, P2pDonationsPopoverComponent]
})
export class P2pDetailsDonationsComponent implements OnInit, AfterViewInit {
  @ViewChild('tabs') tabs!: MdbTabsComponent;

  destroyRef = inject(DestroyRef)
  
  @Input() data = null;
  @Input() activeTab: string = 'donations';
  @Output() selectedDonor = new EventEmitter<any>();
    
  public P2PDonations$: any = this.store.pipe(
    select(selectP2PDonations),
  );

  public P2PPledges$: any = this.store.pipe(
    select(selectModalPledges),
  );
  public p2pPledges = [];

  public userData = null;
  public pledges = [];

  public isTransactionsExist = true;
  public showPledges = false;

  public raised = 0;
  public goal = 0;
  public progressBarHtml = null;

  public optionName = '';
  public displayName = '';
  public name = '';
  public userImage = null;

  public userExelData = null;
  public fileName = '';

  public isModalOpen = false;

  public maxEventCount = 1;
  
  modalRef: MdbModalRef<ConfirmModalComponent> | null = null;

  constructor(
    public store: Store,
    private modalP2pAddDonationsService: ModalP2pAddDonationsService,
    private peerToPeerManageService: PeerToPeerManageService,
    private sanitizer: DomSanitizer,
    public tabsService: CampaignTabsService,
  ) { }

  ngOnInit() {
    this.P2PDonations$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((userData)=> {
      if(userData.length === 0)
        return;

      this.userData = userData;
      this.maxEventCount = this.userData.campaignData.campaignTypeData.maxEventCount;

      if(userData.transactions === null) {
        this.isTransactionsExist = false;
      } else {
        this.isTransactionsExist = true;
      }

      this.optionName = userData.optionInfo?.name ? userData.optionInfo.name : 'Other';
      this.displayName = userData.displayName;
      this.name = this.data.createdByName || userData.userInfo.name;
      
      this.userImage = this.userData.profileImage || this.userData.userInfo.image || "/images/org_logo_default_v2.svg";
      
      this.raised = userData.raised;
      this.goal = userData.goal;
      this.progressBarHtml = this.getProgressBarHtml();
    })

    this.P2PPledges$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((pledges)=> {
      this.p2pPledges = pledges;
    })

    this.pledges = this.data.pledges || [];

    const { pledgePerEvent } = this.data.campaignData.campaignTypeData;
    if(pledgePerEvent) {
      this.showPledges = true;
    }

    this.store.dispatch({
      type: peerToPeerInfo.type,
      payload: this.data.id
    });
  }

  ngAfterViewInit() {
    if (this.showPledges && this.activeTab === 'pledges') {
      this.tabs?.setActiveTab(1);
    }
  }

  getProgressBarHtml () {
    if (this.userData.goal === 0 || this.raised > this.goal) {
      var progressValue = 100
    } else {
      var progressValue = (this.raised/this.goal) * 100
    }

    let raisedText = this.peerToPeerManageService.addCommasToNumber(this.raised)
    let goalText = this.peerToPeerManageService.addCommasToNumber(this.goal)

    var progressBarHtml = `<div class="progress-bar active" role="progressbar" style="width: ${progressValue}%;" 
    aria-valuenow="${progressValue}" aria-valuemin="0" aria-valuemax="100"></div>                                
    <div class="progress-value text-center p2p-detail-progress--text">${raisedText} of ${goalText}</div>`

    const sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(progressBarHtml);
    return sanitizedHtml;
  }

  exportToExel() {
    this.userExelData = this.peerToPeerManageService.getUserExcelData(this.userData.transactions);
    this.fileName = `${this.userData.displayName}_report`
    
    this.peerToPeerManageService.exportToExcel(this.userExelData, this.fileName)
  }

  p2pAddDonationsModalOpen(){
    this.isModalOpen = true;

    const modalRef = this.modalP2pAddDonationsService.open(this.userData, true);
    
    modalRef.onClose.pipe().subscribe(() =>{
      this.modalP2pAddDonationsService.modalRef = null;
      this.isModalOpen = false;
    })
  }

  donorSelected(donor) {
    this.selectedDonor.emit(donor);
  }
}
